import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  VcardParseResponse,
  VcardApplyRequest,
  VcardApplyResponse,
} from '@stfors/shared-types';
import { api } from '../client';

export interface VcardFileInput { filename: string; content: string }

/** Parse one+ dropped .vcf files into reviewable cards (no DB writes). */
export function useParseVcards() {
  return useMutation({
    mutationFn: (files: VcardFileInput[]) =>
      api.post<VcardParseResponse>('/api/contacts/ingest/parse', { files }),
  });
}

/** Apply the reviewed cards — creates/updates people, orgs, contacts, roles. */
export function useApplyVcards() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: VcardApplyRequest) =>
      api.post<VcardApplyResponse>('/api/contacts/ingest/apply', body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['directory'] });
      void qc.invalidateQueries({ queryKey: ['organizations'] });
      void qc.invalidateQueries({ queryKey: ['clients'] });
      void qc.invalidateQueries({ queryKey: ['vendors'] });
      void qc.invalidateQueries({ queryKey: ['contractors'] });
    },
  });
}
